/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { DisclamerText } from '@coursera-web/shared-articles';

import { breakpoints } from '@coursera/cds-core';

import TutorialByLine from 'bundles/tutorials/components/TutorialByLine';

import _t from 'i18n!nls/tutorials';

type Props = {
  authorNames: string;
  date: string;
  title: string;
};

const styles = {
  footerByLine: () => css`
    margin-bottom: 1.5rem;
    ${breakpoints.down('xs')} {
      max-width: 100%;
    }
  `,
};

const Footer = ({ authorNames, date, title }: Props) => (
  <div css={styles.footerByLine}>
    <TutorialByLine authorNames={authorNames} date={date} title={title} />
    <DisclamerText
      message={_t(
        'This content has been made available for informational purposes only. Learners are advised to conduct additional research to ensure that courses and other credentials pursued meet their personal, professional, and financial goals.'
      )}
    />
  </div>
);

export default Footer;
